import React from 'react';

import { Provider } from 'mobx-react';

import IconsLoadedStore from '../stores/loaded';
import Business from './controls/business';
import Clothing from './controls/clothing';
import Communication from './controls/communication';
import Drawing from './controls/drawing';
import Environment from './controls/environment';
import Essentials from './controls/essentials';
import Family from './controls/family';
import Files from './controls/files';
import Finance from './controls/finance';
import Food from './controls/food';
import Gestures from './controls/gestures';
import Gui from './controls/gui';
import Home from './controls/home';
import Leisure from './controls/leisure';
import Maps from './controls/maps';
import Medicine from './controls/medicine';
import Nature from './controls/nature';
import Networking from './controls/networking';
import Photography from './controls/photography';
import Science from './controls/science';
import Security from './controls/security';
import Shopping from './controls/shopping';
import Signs from './controls/signs';
import Sound from './controls/sound';
import Sports from './controls/sports';
import Technology from './controls/technology';
import Text from './controls/text';
import TM3 from './controls/tm3';
import Transportation from './controls/transportation';
import Travel from './controls/travel';
import Users from './controls/users';
import Video from './controls/video';
import Voting from './controls/voting';

export interface IProps {}

const Register: React.FC<IProps> = React.memo(({ children }) => {
  const { current: iconsLoadedStore } = React.useRef(new IconsLoadedStore());
  return (
    <Provider iconsLoadedStore={iconsLoadedStore}>
      <>
        <svg style={{ display: 'none' }}>
          <Essentials />
          <Files />
          <Gui />
          <Gestures />
          <Text />
          <Communication />
          <Technology />
          <Networking />
          <Business />
          <Finance />
          <Shopping />
          <Transportation />
          <Travel />
          <Maps />
          <Signs />
          <Video />
          <Sound />
          <Photography />
          <Security />
          <Voting />
          <Drawing />
          <Users />
          <Environment />
          <Nature />
          <Medicine />
          <Sports />
          <Food />
          <Home />
          <Family />
          <Clothing />
          <Leisure />
          <Science />
          <TM3 />
        </svg>
        {React.Children.toArray(children)}
      </>
    </Provider>
  );
});

Register.displayName = 'Register';

export default Register;
